import * as angular from 'angular';
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {ContractsDialogService} from "../../services/contracts-dialog-service.service";
import {ContractsService} from "../../services/contracts-service.service";

export class ContractDetailsCtrl implements IController {

  contract: any;
  selectedProgramId: any;

  public currentNavItem: any;
  public programType: any;
  public isMultiplePrograms: boolean;


  /* @ngInject */
  constructor(private $state, private contractsDialogService: ContractsDialogService, private contractsService: ContractsService, private $log: ILogService) {
  }

  $onInit() {
    const statesArray = (this.$state.current.name).split('.')
    this.currentNavItem = statesArray[statesArray.length - 1]

    if (this.selectedProgramId) {
      this.programType = _.find(this.contract.entryList, (entry) => {
        return entry.id === this.selectedProgramId;
      })
    }

    this.isMultiplePrograms = _.reduce(this.contract.entryList, (sum, programType) => {
      return sum + (programType.enabled ? 1 : 0);
    }, 0) > 1
  }

  public onRemoveContract(program) {
    this.contractsService.removeProgramFromContract(this.contract.id, program.type)
      .then((contract: any) => {
        const programType = _.find(contract.entryList, (entry) => {
          return entry.enabled;
        })
        this.$state.go('.', {programId: programType.id}, {notify: true, reload: true})
      })
  }

  changeState(stateName) {
    this.$state.go('^.' + stateName, {programId: this.selectedProgramId}, {notify: true, reload: false});
  }


}

angular
  .module('bringoz.admin.contracts')
  .component('contractDetails', {
    bindings: {
      contract: '<',
      selectedProgramId: '<'
    },
    template: require('./contract-details.html').default,
    controller: ContractDetailsCtrl
  });
